import React, { useEffect, useState, useMemo } from "react";
import { db } from "../firebase"; // Import your Firebase Firestore instance
import {
  updateDoc,
  doc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { storage } from "../firebase"; // Import your Firebase storage instance
import { ref, deleteObject, listAll, getDownloadURL } from "firebase/storage";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { MdCloudUpload } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Alert from "../components/Alert";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import {
  syncImageUrls,
  getStorageUrls,
  updateArtistImageURL,
} from "../functions/syncImages";

function parseFileNameFromUrl(url) {
  // Find the index of the second occurrence of "%2"
  const secondPercent2Index = url.indexOf("%2", url.indexOf("%2") + 1);

  // Find the index of the question mark "?"
  const questionMarkIndex = url.indexOf("?");

  // Check if both indices were found in the URL
  if (secondPercent2Index !== -1 && questionMarkIndex !== -1) {
    // Slice the string to extract the file name between the second "%2" and the "?"
    const fileName = url.slice(secondPercent2Index + 3, questionMarkIndex);
    const result = fileName.split("_").slice(2).join("_");
    return decodeURIComponent(result); // Decode any URL-encoded characters
  } else {
    // Return an empty string or handle the error as needed
    return "";
  }
}

const Gallery = ({
  imageUrls,
  setImageUrls,
  user,
  folderName,
  setFolderName,
  docId,
  setDocId,
  location,
}) => {
  //const { docId } = location.state;
  const [showAlert, setShowAlert] = useState(false);
  const [onDeleteConfirmation, setOnDeleteConfirmation] = useState(null);
  const [storageUrls, setStorageUrls] = useState(null);
  const [myDocRef, setMyDocRef] = useState(null);
  const navigate = useNavigate();
  const artistName = localStorage.getItem("fullName");
  const storedDocId = sessionStorage.getItem("docId");
  const [isVisible, setIsVisible] = useState(false);

  setDocId(storedDocId);

  const fetchImages = async () => {
    if (folderName) {
      console.log("This is the folderName", folderName);
    }

    const imagesListRef = ref(storage, `images/${folderName}/`);

    const allImages = await listAll(imagesListRef);

    const urls = await Promise.all(
      allImages.items.map(async (item) => {
        const url = await getDownloadURL(item);
        return url;
      })
    );
    // Update the state with all image URLs
    setImageUrls(urls);
    const myDocId = sessionStorage.getItem("docId");

    const documentRef = doc(db, "artists", myDocId);
    await updateDoc(documentRef, {
      imageURLs: urls,
    });

    setStorageUrls(urls);
    setImageUrls(urls);
  };

  useEffect(() => {
    folderName = localStorage.getItem("fullName");
    setFolderName(folderName);

    fetchImages();

    // Fetch images when the component mounts
  }, [setImageUrls]);

  const handleDelete = async (index) => {
    // Show the alert and await user response
    setShowAlert(true);
    // Function to handle user confirmation
    const handleUserConfirmation = async (confirmed) => {
      setShowAlert(false); // Close the alert

      if (confirmed) {
        const imageUrlToDelete = imageUrls[index];
        setImageUrls((prevImageUrls) =>
          prevImageUrls.filter((_, i) => i !== index)
        );
        const fileRef = ref(storage, imageUrlToDelete);
        try {
          await deleteObject(fileRef);
          // Synchronize storage and urls in the database
          getStorageUrls(folderName)
            .then((storageUrls) => {
              if (storageUrls) {
                console.log(
                  "These are URLs from storage after delete",
                  storageUrls
                );
                console.log("This is the Gallery docId", docId);
              } else {
                console.log("Waiting++++");
              }
            })
            .catch((error) => {
              console.error("Error while getting URLs from storage:", error);
            });
          //console.log("Image Urls are", imageUrls);
        } catch (error) {
          console.error("Error deleting file:", error);
        }
        const collectionName = "artists";
        //syncImageUrls(collectionName, docId, storageUrls);
      } else {
        // The user chose "No," so do nothing or handle it as needed
      }
    };

    // Pass the handleUserConfirmation function as onYes callback
    setOnDeleteConfirmation(() => handleUserConfirmation);
  };

  return (
    <>
      <Container className='mt-4'>
        <Row>
          {" "}
          <Col lg={"12"} className='d-flex justify-content-between'>
            <h1 className='mt-3'>{artistName.replace(/_/g, " ")} Gallery</h1>
            <span>
              {imageUrls && (
                <div className='whiteText image-title'>
                  Images Left to Upload: {7 - imageUrls.length}
                </div>
              )}
              <Button
                className='btn btn-primary mb-4'
                onClick={() => navigate("/ImageUpload")}>
                <MdCloudUpload size={20} style={{ marginRight: "5px" }} />{" "}
                Upload Images
              </Button>
            </span>
          </Col>
          <Col className='mb-2'>
            <p>
              Upload the images that you would like to include in your
              submission. When you are finished uploading, return to your
              profile.
            </p>
          </Col>
        </Row>
        <Row>
          {showAlert && (
            <Alert
              message='Are you sure you want to delete this file?'
              onYes={() => {
                if (onDeleteConfirmation) {
                  onDeleteConfirmation(true);
                }
              }}
              onNo={() => setShowAlert(false)}
            />
          )}
        </Row>
        <Row style={{ padding: "10px" }}>
          {imageUrls.length === 0 && (
            <>
              <div
                className='image-container-dk mb-5 modal-content'
                onClick={() => navigate("/ImageUploadModal")}>
                <h3 className='text-center'>
                  Click here to Upload Images for your Gallery.
                </h3>
                <p>Or click the Upload Images button in the upper right.</p>
              </div>{" "}
            </>
          )}
        </Row>
        <Row>
          {imageUrls.map((imageUrl, index) => (
            <Col
              key={index}
              xs={12}
              md={4}
              lg={3}
              className='d-flex justify-content-center '>
              <div className='mb-4 one-pix-border'>
                <div className='delete-image-header'>
                  <div
                    className='deleteImage'
                    onClick={() => handleDelete(index)}>
                    <MdDeleteForever size={"24"} align='right' />
                  </div>

                  <img
                    src={imageUrl}
                    alt={`Img ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />

                  <h6 className='whiteText text-center d-flex justify-content-center mt-2 mb-3 img-title'>
                    {parseFileNameFromUrl(imageUrl)}
                  </h6>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default Gallery;
